import { render } from "./AdminSystem.vue?vue&type=template&id=755aada2"
import script from "./AdminSystem.vue?vue&type=script&lang=js"
export * from "./AdminSystem.vue?vue&type=script&lang=js"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__